import { render } from "./TestEcharts.vue?vue&type=template&id=8c5dbdb4&scoped=true"
import script from "./TestEcharts.vue?vue&type=script&lang=js"
export * from "./TestEcharts.vue?vue&type=script&lang=js"

import "./TestEcharts.vue?vue&type=style&index=0&id=8c5dbdb4&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c5dbdb4"]])

export default __exports__